import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { Icon } from "semantic-ui-react";
import ToggleButton from "./ToggleButton";

const links = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/portfolio", label: "Portfolio" },
  { to: "/contact", label: "Contact" },
];

const Nav = () => {
  const [open, setOpen] = useState(false);

  const renderLinks = () =>
    links.map((link) => (
      <NavLink
        key={link.to}
        to={link.to}
        end={link.to === "/"}
        className={({ isActive }) => `nav-link${isActive ? " active" : ""}`}
        onClick={() => setOpen(false)}
      >
        {link.label}
      </NavLink>
    ));

  return (
    <nav aria-label="Primary navigation">
      <div className="header-actions">
        <div className="nav-desktop">{renderLinks()}</div>
        <ToggleButton />
        <button
          className="mobile-menu-button"
          type="button"
          aria-label="Open navigation menu"
          aria-expanded={open}
          onClick={() => setOpen((current) => !current)}
        >
          <Icon name={open ? "close" : "sidebar"} />
        </button>
      </div>
      <div className={`mobile-menu${open ? " open" : ""}`}>{renderLinks()}</div>
    </nav>
  );
};

export default Nav;
